import React from 'react'
import MenuButton from './button/MenuButton'
import GlobalStorage from './storage/GlobalStorage';

export default class TBCEditorMainMenu extends React.Component{

  constructor(props)
  {
    super(props);
    
    this.GS = new GlobalStorage()

    this.state = {
      href: `root`,
    }

    this.items_root = {
      name: `root`,
      menu: [        
        {is_href: true, value: `Story`, label: `創作故事`},
        {is_href: true, value: `StoryEpisode`, label: `創作故事章節`},
        {is_href: true, value: `Scenes`, label: `編輯故事`},                        
      ]
    }

    this.items_Story = {
      name: `Story`,
      menu: [
        {is_href: true, value: `root`, label: `上一頁`}
      ]
    }

    this.items_StoryEpisode = {
      name: `StoryEpisode`,
      menu: [
        {is_href: true, value: `root`, label: `上一頁`}
      ]
    }

    this.items_Scenes = {
      name: `Scenes`,
      menu: [
        {is_href: true, value: `root`, label: `上一頁`},
        {is_href: false, value: `Play`, label: `更新並播放`},
        {is_href: false, value: `Export`, label: `下載故事存檔`},
        //{is_href: false, value: `Email`, label: `投稿 (Email)`},        
        {is_href: false, value: `CreateEpisode`, label: `上傳`},
        
      ]
    }

    

    this.items_Import = {
      name: `Import`,
      menu: [
        {is_href: true, value: `root`, label: `上一頁`}
      ]
    }
  }

  test()
  {
    alert('test"')
  }

  getBundle()
  {
    return this[`items_${this.state.href}`];
  }

  setBundle(href, callback)
  {
    this.setState({href: href}, callback && callback());
  }

  doAction(item)
  { 
    if (item.is_href)
    {
      this.setBundle(item.value, () => {
        requestAnimationFrame(() => {
          this.props.doAction && this.props.doAction(item, this.getBundle());
        })
      });
      return;
    }
    this.props.doAction && this.props.doAction(item);
  }


  render()
  {

    return (
        <div style={{paddingTop:`15px`,position: `relative`, height: `100%`}} className={'text-left p-3'}>
          { 
            this.getBundle().menu.map((item) => {
              
              return (
                  <MenuButton
                      onClick={() => {this.doAction(item)}}>
                    {item.label}
                  </MenuButton>
              )
            })
          }
        </div>
    )
  }
}